<app-page-title icon="fa-history" title="Logs de Auditoria"></app-page-title>

<section class="filter-card">
  <form class="filter-grid" (ngSubmit)="applyFilter()">
    <div class="filter-field">
      <label for="auditTable">Cadastro (tabela)</label>
      <input
        id="auditTable"
        name="auditable_type"
        type="text"
        class="form-control"
        list="auditTables"
        placeholder="Ex.: campaigns"
        autocomplete="off"
        [(ngModel)]="filter.auditable_type"
        data-testid="input-auditable-type"
      />
      <datalist id="auditTables">
        <option *ngFor="let t of tables" [value]="t.value">{{ t.label }}</option>
      </datalist>
    </div>

    <div class="filter-field">
      <label for="auditRecord">ID do registro</label>
      <input
        id="auditRecord"
        name="auditable_id"
        type="text"
        class="form-control"
        placeholder="uuid ou chave"
        autocomplete="off"
        [(ngModel)]="filter.auditable_id"
        data-testid="input-auditable-id"
      />
    </div>

    <div class="filter-field">
      <label for="auditAction">Ação</label>
      <select id="auditAction" name="action" class="form-select" [(ngModel)]="filter.action" data-testid="select-action">
        <option [ngValue]="null">Todas</option>
        <optgroup label="Cadastros">
          <option *ngFor="let a of crudActions" [ngValue]="a.value">{{ a.label }}</option>
        </optgroup>
        <optgroup label="Login">
          <option *ngFor="let a of loginActions" [ngValue]="a.value">{{ a.label }}</option>
        </optgroup>
      </select>
    </div>

    <div class="filter-field">
      <label for="auditSource">Origem</label>
      <select id="auditSource" name="source" class="form-select" [(ngModel)]="filter.source" data-testid="select-source">
        <option [ngValue]="null">Todas</option>
        <option *ngFor="let s of sources" [ngValue]="s.value">{{ s.label }}</option>
      </select>
    </div>

    <div class="filter-field user-field">
      <label for="auditOwner">Conta afetada <span class="optional">(dona do registro)</span></label>
      <div class="user-input-wrapper">
        <input
          #inputOwner
          id="auditOwner"
          name="owner_user"
          type="text"
          class="form-control"
          placeholder="Buscar por nome ou e-mail..."
          [formControl]="ownerControl"
          [matAutocomplete]="autoOwner"
          (input)="filterOwner()"
          data-testid="input-owner"
        />
        <button
          *ngIf="ownerControl.value"
          type="button"
          class="btn-clear-user"
          (click)="clearOwner()"
          ngbTooltip="Limpar"
          data-testid="btn-clear-owner"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>
      <mat-autocomplete requireSelection #autoOwner="matAutocomplete" [displayWith]="displayUser">
        <mat-option [value]="user" *ngFor="let user of filteredOwners$ | async">
          {{ displayUser(user) }}
        </mat-option>
      </mat-autocomplete>
    </div>

    <div class="filter-field user-field">
      <label for="auditOperator">Alterado por <span class="optional">(operador)</span></label>
      <div class="user-input-wrapper">
        <input
          #inputOperator
          id="auditOperator"
          name="operator_user"
          type="text"
          class="form-control"
          placeholder="Buscar por nome ou e-mail..."
          [formControl]="operatorControl"
          [matAutocomplete]="autoOperator"
          (input)="filterOperator()"
          data-testid="input-operator"
        />
        <button
          *ngIf="operatorControl.value"
          type="button"
          class="btn-clear-user"
          (click)="clearOperator()"
          ngbTooltip="Limpar"
          data-testid="btn-clear-operator"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>
      <mat-autocomplete requireSelection #autoOperator="matAutocomplete" [displayWith]="displayUser">
        <mat-option [value]="user" *ngFor="let user of filteredOperators$ | async">
          {{ displayUser(user) }}
        </mat-option>
      </mat-autocomplete>
    </div>

    <div class="filter-field">
      <label for="auditFrom">De</label>
      <input id="auditFrom" name="from" type="date" class="form-control" [(ngModel)]="filter.from" data-testid="input-from" />
    </div>

    <div class="filter-field">
      <label for="auditTo">Até</label>
      <input id="auditTo" name="to" type="date" class="form-control" [(ngModel)]="filter.to" data-testid="input-to" />
    </div>

    <div class="filter-actions">
      <button type="button" class="btn btn-outline-light" *ngIf="hasDraft" (click)="clearFilters()" data-testid="btn-clear-filters">
        <i class="fa fa-eraser me-1"></i> Limpar
      </button>
      <button type="submit" class="btn btn-primary" data-testid="btn-apply-filter">
        <i class="fa fa-filter me-1"></i> Filtrar
      </button>
    </div>
  </form>
</section>

<div class="loading-block" *ngIf="isLoading" data-testid="audit-logs-loading">
  <i class="fa fa-spinner fa-spin me-2"></i> Carregando logs...
</div>

<div class="alert alert-danger" *ngIf="!isLoading && error" data-testid="audit-logs-error">
  <i class="fa fa-exclamation-triangle me-1"></i> {{ error }}
</div>

<div *ngIf="!isLoading && !error && result">
  <div class="default-period" *ngIf="defaultPeriodFrom" data-testid="audit-logs-default-period">
    <i class="fa fa-calendar me-1"></i>
    Sem "De" informado: mostrando desde {{ defaultPeriodFrom + 'T00:00:00' | date : 'dd/MM/yyyy' }}.
    Preencha "De" para ver registros mais antigos.
  </div>

  <ng-container *ngIf="result.data?.length > 0; else empty">
    <div class="result-count">
      {{ result.total | number }} {{ result.total === 1 ? 'registro' : 'registros' }}
    </div>

    <div class="log-row" *ngFor="let log of result.data; trackBy: trackById" data-testid="audit-log-row">
      <div class="log-main">
        <div class="log-line">
          <span class="action-badge" [ngClass]="actionClass(log.action)">{{ actionLabel(log.action) }}</span>
          <span class="log-table">{{ tableLabel(log.auditable_type) }}</span>
          <span class="log-login" *ngIf="isLogin(log)" data-testid="audit-log-login">
            {{ loginWho(log) }}
            <span class="muted" *ngIf="loginReason(log) as reason" data-testid="audit-log-login-reason">· {{ reason }}</span>
            <span class="muted" *ngIf="loginMethod(log) as method">· {{ method }}</span>
          </span>
          <button
            *ngIf="!isLogin(log)"
            type="button"
            class="link-btn log-record"
            (click)="filterByRecord(log)"
            ngbTooltip="Ver histórico deste registro"
            data-testid="btn-filter-record"
          >
            <code>{{ log.auditable_type }}#{{ log.auditable_id }}</code>
          </button>
        </div>

        <div class="log-meta">
          <span class="log-date">
            <i class="fa fa-clock-o me-1"></i>{{ log.created_at | date : 'dd/MM/yyyy, HH:mm:ss' }}
          </span>
          <span>
            <i class="fa fa-user me-1"></i>
            <button
              *ngIf="log.user_id; else systemUser"
              type="button"
              class="link-btn"
              (click)="filterByOperator(log)"
              ngbTooltip="Ver tudo o que este operador alterou"
              data-testid="btn-filter-operator"
            >
              {{ log.user_name || log.user_email || log.user_id }}
            </button>
            <ng-template #systemUser><i>{{ isLogin(log) ? 'Sem conta' : 'Sistema' }}</i></ng-template>
          </span>
          <span class="muted">
            <i class="fa fa-sign-in me-1"></i>{{ sourceLabel(log.source) }}
          </span>
          <span class="muted" *ngIf="isLogin(log) && log.ip">
            <i class="fa fa-globe me-1"></i>{{ log.ip }}
          </span>
          <span *ngIf="log.owner_user_id && log.owner_user_id !== log.user_id">
            <i class="fa fa-building-o me-1"></i>
            <button
              type="button"
              class="link-btn"
              (click)="filterByOwner(log)"
              ngbTooltip="Ver tudo o que mudou nesta conta"
              data-testid="btn-filter-owner"
            >
              Conta {{ log.owner_user_id | slice : 0 : 8 }}…
            </button>
          </span>
        </div>

        <div class="log-fields muted" *ngIf="!isLogin(log) && log.changed_fields?.length">
          <i class="fa fa-pencil me-1"></i>
          {{ log.changed_fields.length }} {{ log.changed_fields.length === 1 ? 'campo' : 'campos' }}:
          {{ fieldsPreview(log) }}
        </div>
      </div>

      <div class="log-actions">
        <button type="button" class="btn btn-sm btn-primary" (click)="openDetail(log)" data-testid="btn-detail">
          <i class="fa fa-eye me-1"></i> Detalhes
        </button>
      </div>
    </div>

    <app-pagination
      *ngIf="result.total > result.per_page"
      [currentPage]="result.current_page"
      [itemsPerPage]="result.per_page"
      [totalItems]="result.total"
      (pageChanged)="pageChanged($event)"
    ></app-pagination>
  </ng-container>

  <ng-template #empty>
    <div class="empty-state" data-testid="audit-logs-empty">
      <i class="fa fa-history"></i>
      <p>Nenhum log de auditoria encontrado{{ hasFilter ? ' para os filtros informados' : '' }}.</p>
    </div>
  </ng-template>
</div>

<ng-template #detailModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="auditLogDetailTitle">
      {{ detail && isLogin(detail) ? 'Detalhe do login' : 'Detalhe da alteração' }}
      <small class="d-block muted" *ngIf="detail">
        {{ tableLabel(detail.auditable_type) }} · {{ actionLabel(detail.action) }}
      </small>
    </h4>
    <button type="button" class="btn-close" aria-label="Fechar" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body audit-detail">
    <div *ngIf="detailLoading" class="text-center py-2 muted" data-testid="audit-detail-loading">
      <i class="fa fa-spinner fa-spin me-1"></i> Carregando...
    </div>

    <div *ngIf="!detailLoading && detailError" class="alert alert-danger" data-testid="audit-detail-error">
      <i class="fa fa-exclamation-triangle me-1"></i> {{ detailError }}
    </div>

    <ng-container *ngIf="detail && !detailError">
      <dl class="detail-grid">
        <dt>Data</dt>
        <dd>{{ detail.created_at | date : 'dd/MM/yyyy, HH:mm:ss' }}</dd>

        <dt>Ação</dt>
        <dd><span class="action-badge" [ngClass]="actionClass(detail.action)">{{ actionLabel(detail.action) }}</span></dd>

        <dt>Cadastro</dt>
        <dd>{{ tableLabel(detail.auditable_type) }} <code>{{ detail.auditable_type }}</code></dd>

        <ng-container *ngIf="isLogin(detail)">
          <dt>Resultado</dt>
          <dd data-testid="audit-detail-login-result">
            {{ actionLabel(detail.action) }}
            <span class="muted" *ngIf="loginReason(detail) as reason">· {{ reason }}</span>
          </dd>

          <dt>Método</dt>
          <dd><span *ngIf="loginMethod(detail) as method; else none">{{ method }}</span></dd>
        </ng-container>

        <ng-container *ngIf="!isLogin(detail) || detail.auditable_id">
          <dt>{{ isLogin(detail) ? 'Usuário' : 'ID do registro' }}</dt>
          <dd>
            <code>{{ detail.auditable_id }}</code>
            <button type="button" class="link-btn ms-2" (click)="copy(detail.auditable_id)" ngbTooltip="Copiar">
              <i class="fa fa-copy"></i>
            </button>
          </dd>
        </ng-container>

        <dt>Conta afetada</dt>
        <dd>
          <ng-container *ngIf="detail.owner_user_id; else none">
            <code>{{ detail.owner_user_id }}</code>
            <button type="button" class="link-btn ms-2" (click)="copy(detail.owner_user_id)" ngbTooltip="Copiar">
              <i class="fa fa-copy"></i>
            </button>
          </ng-container>
        </dd>

        <dt>{{ isLogin(detail) ? 'Quem entrou' : 'Alterado por' }}</dt>
        <dd>
          <ng-container *ngIf="detail.user_id; else systemDetail">
            {{ detail.user_name }}
            <span class="muted" *ngIf="detail.user_email">({{ detail.user_email }})</span>
            <code class="d-block">{{ detail.user_id }}</code>
          </ng-container>
          <ng-template #systemDetail>
            <span *ngIf="isLogin(detail); else systemText">{{ loginWho(detail) }} <span class="muted">(sem conta)</span></span>
            <ng-template #systemText><i>Sistema</i></ng-template>
          </ng-template>
        </dd>

        <dt>Origem</dt>
        <dd>{{ sourceLabel(detail.source) }}</dd>

        <dt>Contexto</dt>
        <dd><code *ngIf="detail.context; else none">{{ detail.context }}</code></dd>

        <dt>IP</dt>
        <dd><span *ngIf="detail.ip; else none">{{ detail.ip }}</span></dd>

        <dt>ID do log</dt>
        <dd><code>{{ detail.id }}</code></dd>
      </dl>

      <ng-template #none><span class="muted">—</span></ng-template>

      <h5 class="changes-title">Campos</h5>

      <div *ngIf="!detail.changed_fields?.length" class="muted" data-testid="audit-detail-no-fields">
        Nenhum campo registrado para este evento.
      </div>

      <div class="table-responsive" *ngIf="detail.changed_fields?.length">
        <table class="table table-sm mb-0 changes-table">
          <thead>
            <tr>
              <th>Campo</th>
              <th *ngIf="!isLogin(detail)">De</th>
              <th>{{ isLogin(detail) ? 'Valor' : 'Para' }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let change of detail.changed_fields" data-testid="audit-detail-change">
              <td><code>{{ change.field }}</code></td>
              <ng-container *ngIf="isMasked(detail, change); else values">
                <td [attr.colspan]="isLogin(detail) ? 1 : 2" class="muted" data-testid="audit-detail-masked">
                  <i class="fa fa-lock me-1"></i> Valor não registrado por segurança
                </td>
              </ng-container>
              <ng-template #values>
                <td class="value-old" *ngIf="!isLogin(detail)">
                  <pre *ngIf="isStructured(change.old); else oldText">{{ formatValue(change.old) }}</pre>
                  <ng-template #oldText>{{ formatValue(change.old) }}</ng-template>
                </td>
                <td class="value-new">
                  <pre *ngIf="isStructured(change.new); else newText">{{ formatValue(change.new) }}</pre>
                  <ng-template #newText>{{ formatValue(change.new) }}</ng-template>
                </td>
              </ng-template>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="modal.dismiss()">Fechar</button>
  </div>
</ng-template>
